import { ReviewActionButtons } from "./ActionButtons/ReviewActionButtons";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useFlowState } from "@/hooks/useFlowState";
import { BuildSteps, Flows } from "@/types/flows";
import { MIN_INFERENCES_SAMPLE } from "@/constants/inference";
import { useCurrentMedia, useTextPromptMode } from "@/store";

export const ReviewSidebarContent = () => {
    const {
        imagesNeededToDeploy,
        hasEnoughDataToDeploy,
        currentPromptingData,
        currentInferenceSampledData
    } = useComputedValues();
    const { flow, step } = useFlowState();
    const currentMedia = useCurrentMedia();
    const textPromptMode = useTextPromptMode();

    const isVideo = currentMedia?.file.isVideo;
    const shouldShowDeployFlow = isVideo || hasEnoughDataToDeploy;
    const isReviewStep = flow === Flows.BUILD && step === BuildSteps.REVIEW;

    // Calculate current image count using the same logic as ComputedValuesProvider
    const promptedFiles = currentPromptingData.map((promptData) => `${promptData.file_uuid}-0`);
    const inferredFiles = currentInferenceSampledData.map(
        (inferenceData) => `${inferenceData.file_uuid}-${inferenceData.frame_number}`
    );
    const allFiles = new Set([...promptedFiles, ...inferredFiles]);
    const currentImageCount = allFiles.size;
    const totalImagesNeeded = MIN_INFERENCES_SAMPLE;

    let title: string;
    let description: string | undefined;

    if (shouldShowDeployFlow) {
        title = "How is your model looking?";
        description =
            "You can adjust the slider to show more or less objects before taking your next action.";
    } else {
        title = "Let's try on more data.";
        description = `Upload ${imagesNeededToDeploy} more images or a video to improve your model.`;
    }

    return (
        <>
            <SidebarHeader
                title={title}
                description={description}
                showImageCountChip={
                    isReviewStep &&
                    !isVideo &&
                    !textPromptMode &&
                    currentImageCount < totalImagesNeeded
                }
                currentImageCount={currentImageCount}
                totalImagesNeeded={totalImagesNeeded}
            />
            <ReviewActionButtons forceVideoFlow={shouldShowDeployFlow} />
        </>
    );
};
